import { render, staticRenderFns } from "./LangIcon.vue?vue&type=template&id=e2db4c16&scoped=true&"
import script from "./LangIcon.vue?vue&type=script&lang=js&"
export * from "./LangIcon.vue?vue&type=script&lang=js&"
import style0 from "./LangIcon.vue?vue&type=style&index=0&id=e2db4c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2db4c16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dilan/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2db4c16')) {
      api.createRecord('e2db4c16', component.options)
    } else {
      api.reload('e2db4c16', component.options)
    }
    module.hot.accept("./LangIcon.vue?vue&type=template&id=e2db4c16&scoped=true&", function () {
      api.rerender('e2db4c16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PUI/Controls/LangIcon.vue"
export default component.exports